// Common UrbanWizardry.online styles
import './uw-online-shared/UwOnline.css';

import './style/App.css';
import './style/Grid.css';
import './style/Keyboard.css';
import './style/Words.css';


//import React from 'react';
import { useState, useEffect } from "react";
import { useMediaQuery } from 'react-responsive';

import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';


import { Navbar } from './uw-online-shared/UwOnlineComponents.js';

import { DesktopNav, TabletNav, MobileNav } from './Components';
import { GridSection } from './Grid';
import { maxGridDimension, calSquareSize } from './uw-online-shared/Screen.js'

import { SquareValue, SquareValues } from "./Values"
import { WordList } from './Words';
import { Puzzle } from './Values';
import { HelpModal, StatsSettingsModal, SolvedModal, RestartConfirmModal } from './Modals';
import { getTodaysPuzzle } from './PuzzleDb'
import { Stats } from './Stats';
import { convertSeconds } from './Time.ts'

const puzzleCookieName = "UrbanWizardry.GogenOnline.PuzzleState"
const statsCookieName = "UrbanWizardry.GogenOnline.Stats"

const SHARE_GRID = `
🟩✅🟩✅🟩
✅✅✅✅✅
🟩✅🟩✅🟩
✅✅✅✅✅
🟩✅🟩✅🟩
`

const FullWindow = ({children}) => {
  return (
    <div style={{height: window.innerHeight, display: "flex", flexDirection:"column", justifyContent:"space-between"}}>
      {children}
    </div>
  )
}

function keyboardLayoutFromLetters(letters) {
  const topRow = letters.slice(0,8)
  const bottomRow = letters.slice(8);

  return {
    'default': [
      topRow.join(" "),
      bottomRow.join(" "),
      'Delete Note&nbsp;Mode'
    ]
  }
}

const keyDisplayOptions = {
  '{bksp}': '&nbsp; delete&nbsp;'
}

function buildKeyboardStyle(fixedLetters, usedLetters, noteMode) {
  const style = [
    {
      class: "fixedLetters",
      buttons: fixedLetters.join(" ")
    },
    {
      class: "usedLetters",
      buttons: usedLetters.join(" ")
    }
  ];

  if (noteMode) {
    style.push({
      class: "noteModeOn",
      buttons: noteMode ? "Note&nbsp;Mode" : ""
    });
  }
  
  return style;
}

const App = () => {
	// Function to get a cookie by name.
  // Returns null if cookie not found, otherwise returns a Javascript object
	const getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return JSON.parse(atob(parts.pop().split(";").shift()));
		return null;
	};

  // MARK: Puzzle cookie
	const setCookieFunction = (name, value, days) => {
		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
    const b64value = btoa(JSON.stringify(value));
		document.cookie = name + "=" + b64value + expires + "; path=/";
	};

  const getPuzzleCookie = () => {
    return getCookie(puzzleCookieName)
  }

  const getPuzzleState = () => {
    const cookie = getPuzzleCookie();
    if (cookie != null) {
      return cookie;
    }
    return null;
  }

	// Function to update the cookie
	const updatePuzzleCookie = (v) => {
    if (v != null){
		  setCookieFunction(puzzleCookieName, v, 7); // Set cookie for 7 days
    }
	};

  // MARK: Stats cookie
  const getStatsCookie = () => {
    return getCookie(statsCookieName)
  }

  // Function to update the stats cookie
	const updateStatsCookie = (s) => {
	  setCookieFunction(statsCookieName, s, 365); // Set cookie for 1 year, stats reset after that if not updated
	};

  const getStats = () => {
    const cookie = getStatsCookie();
    if (cookie == null) {
      return new Stats(0, 0, 0);
    }

    return new Stats(cookie.played, cookie.streak, cookie.averageSeconds);
  }

  const addSecondsToStats = (seconds) => {
    let s = new Stats(stats.played, stats.streak, stats.averageSeconds);
    s.addStatsGame(seconds);
    setStats(s);
    updateStatsCookie(s);
  }

  const findWords = () => {
    const keyPressFoundWords = [];

    for (var w=0; w < puzzle.words.length; w++) {
      const word = puzzle.words[w];
      if (values.findWord(word)) {
        keyPressFoundWords.push(word)
      }
    }

    setFoundWords(keyPressFoundWords);
    return keyPressFoundWords.length;
  }

  // MARK: State
  let [noteMode, setNoteMode] = useState(false);
  let [foundWords, setFoundWords] = useState([]);

  const todaysPuzzle = getTodaysPuzzle();
  const puzzleRaw = todaysPuzzle.puzzle;
  const puzzle = new Puzzle(
    todaysPuzzle.dateId,
    todaysPuzzle.number,
    puzzleRaw.letters.split(""),
    puzzleRaw.words
  );

  const currentValues = getPuzzleState();
  let squareValues = (currentValues != null && todaysPuzzle.dateId == currentValues.dateId) ? SquareValues.fromJson(currentValues) : puzzle.startingValues();
  let [values, setValues] = useState(squareValues);

  const modifyValues = (modifyFunc) => {
    let newValues = new SquareValues(values.dateId, values.rows, values.secondsPlayed, values.complete);
    modifyFunc(newValues);
    setValues(newValues);
    updatePuzzleCookie(newValues);
  }

  const resetValues = () => {
    const newValues = puzzle.startingValues();
    setValues(newValues);
    updatePuzzleCookie(newValues);
  }

  const [stats, setStats] = useState(getStats());

  const [finishedModalIsOpen, setFinishedModalIsOpen] = useState(false);
  const [helpModalIsOpen, setHelpModalIsOpen] = useState(false);
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false);
  const [restartModalIsOpen, setRestartModalIsOpen] = useState(false);

  const [timerSeconds, setTimerSeconds] = useState(values.secondsPlayed);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!values.complete) {
        setTimerSeconds(timerSeconds+1);
        modifyValues((v) => {v.secondsPlayed = timerSeconds;})
      }
    }, 1000);
    return () => {clearInterval(interval);}
  })
    
  // MARK: Device check
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const resDivider = 1; //useMediaQuery({minResolution: "2dppx"}) ? 2 : 1

  const fixedLetters = puzzle.getFixedLetters();

  let buttonTheme = buildKeyboardStyle(fixedLetters, values.getUsedLetters(), noteMode);
  const squareSize = calSquareSize(resDivider, 3, 1);
  const outerSquareSize = calSquareSize(resDivider, 0, 0);

  const keyboardLetters = puzzle.getUnfixedLetters().sort();
  const keyboardLayout = keyboardLayoutFromLetters(keyboardLetters);

  // MARK: Sharing
  const shareUrl = function() {
    if (!navigator.share) {
      return;
    }

    navigator.share({
            //url: "https://gogen.online",
            title: "GOGEN.online #"+puzzle.number,
            text: "GOGEN.online #"+puzzle.number+SHARE_GRID+"Puzzle solved in:\n"+convertSeconds(values.secondsPlayed)
        })
        .then(() => { console.log("Shared"); })
        .catch((error) => { console.log("Sharing Failed") });
  }

  // Ensure words on a reloaded part-completed puzzle are found
  useEffect(()=>{
    findWords();
  }, [])
  
  return (
    <FullWindow>
      <Navbar>
        {isDesktop && <DesktopNav 
                        settingsPopup={() => {setSettingsModalIsOpen(true)}} 
                        helpPopup={() => {setHelpModalIsOpen(true)}}
                        restartConfirmPopup={() => {setRestartModalIsOpen(true)}}
                        restartEnabled={!values.complete}
                      />}

        {isTablet && <TabletNav settingsPopup={() => {setSettingsModalIsOpen(true)}} helpPopup={() => {setHelpModalIsOpen(true)}}/>}

        {isMobile && <MobileNav 
                      settingsPopup={() => {setSettingsModalIsOpen(true)}} 
                      helpPopup={() => {setHelpModalIsOpen(true)}}
                      restartConfirmPopup={() => {setRestartModalIsOpen(true)}}
                      restartEnabled={!values.complete}
                    />}
      </Navbar>
      <GridSection 
        squareSize={squareSize} 
        values={values}
        maxWidth={maxGridDimension(resDivider)+"px"}
        handleGridSquareClick={
          (row, col) => {
            if (values.canSelect(row, col)) {
              modifyValues((v) => {
                v.unselectAll()
                v.select(row, col)
              })
            } 
          }
        }
      />

      <WordList words={puzzle.words} foundWords={foundWords} maxWidth={maxGridDimension(resDivider)+"px"}/>
      <div style={{width: maxGridDimension(resDivider)+"px"}}>
      <Keyboard
        layout={keyboardLayout}
        display={keyDisplayOptions}
        buttonTheme={buildKeyboardStyle(fixedLetters, values.getUsedLetters(), noteMode)}
        onKeyPress={(button) => {
            // You can't use the keyboard if the puzzle is completed
            if (!values.complete) {
              if (fixedLetters.indexOf(button) != -1) {
                // Fixed letter
                return
              } else if(button == "Delete") {
                modifyValues((v) => {v.setSelectedLetter("")})
              } else if(button == "Note&nbsp;Mode") {
                setNoteMode(!noteMode);
              } else {
                modifyValues((v) => {
                  if (noteMode) {
                    if (!values.letterUsed(button)) {
                      v.toggleSelectedNote(button)
                    }
                  } else {
                    v.setSelectedLetter(button)
                  }
                })
              }

              const wordsFound = findWords();

              console.log("Founds words: "+wordsFound+" vs total "+puzzle.words.length);
              if (wordsFound == puzzle.words.length) {
                // SOLVED!
                if (!values.complete) {
                  addSecondsToStats(values.secondsPlayed);
                }
                modifyValues((v)=>{v.complete = true;});
                setFinishedModalIsOpen(true);
              }
            }
          }
        }
      /></div>

      <SolvedModal 
        isOpen={finishedModalIsOpen} 
        solvedTime={values.secondsPlayed} 
        onShare={shareUrl} 
        closer={()=>{setFinishedModalIsOpen(false)}}
        colourCode="007700"
      />
      <HelpModal 
        isOpen={helpModalIsOpen} 
        closer={() => {setHelpModalIsOpen(false);}}
        colourCode="007700"  
      />
      <StatsSettingsModal 
        isOpen={settingsModalIsOpen} 
        closer={() => {setSettingsModalIsOpen(false);}} 
        stats={stats} 
        completeToday={values.complete} 
        completedSeconds={values.complete ? values.secondsPlayed : -1}
        onShare={shareUrl}
        colourCode="007700"
      />
      <RestartConfirmModal 
        isOpen={restartModalIsOpen}
        closer={()=>{setRestartModalIsOpen(false)}}
        onYes={()=>{resetValues(); setRestartModalIsOpen(false)}}
        onNo={()=>{setRestartModalIsOpen(false)}}
        colourCode="007700"
      />

    </FullWindow>
  );
};

export default App;
